import { useEffect, useState } from 'react';
import { useKeycloakUserState } from '../context/keycloak-user';
import { JETFM_MCP_OCF_ENABLED_COUNTRY_CODES } from '../models';
import useFMFeatureFlag from './use-fm-featureflag';

const useOCFStatus = () => {
  const [isOCFEnabled, setIsOCFEnabled] = useState<boolean | null>(null);

  const { restaurant } = useKeycloakUserState();
  const ocfEnabledCountryCodes = useFMFeatureFlag(JETFM_MCP_OCF_ENABLED_COUNTRY_CODES) as
    | string
    | undefined;

  useEffect(() => {
    if (!restaurant?.country || !ocfEnabledCountryCodes?.trim()) {
      setIsOCFEnabled(false);
      return;
    }

    const enabledCountries = ocfEnabledCountryCodes
      .split(',')
      .map((c) => c.trim().toUpperCase())
      .filter(Boolean);

    setIsOCFEnabled(enabledCountries.includes(restaurant.country.toUpperCase()));
  }, [restaurant?.country, ocfEnabledCountryCodes]);

  return { isOCFEnabled };
};

export default useOCFStatus;
